import React, { useEffect, useState } from "react";
import "../../styles/theme-dark.css";
import "../Clientes.css";
import axios from "../../api/axios";
import { useNavigate, useParams } from "react-router-dom";
import ProveedorInput from "../ProveedorInput";
import { useLocation } from "react-router-dom";



export default function CompraForm() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [proveedorNombre, setProveedorNombre] = useState("");
  const [numeroFactura, setNumeroFactura] = useState("");
  const [fecha, setFecha] = useState("");
  const [fechaVencimiento, setFechaVencimiento] = useState("");
  const [tipo, setTipo] = useState("nacional");
  const [lineas, setLineas] = useState([{ concepto: "", precio: 0, iva: 0 }]);
  const location = useLocation();
const params = new URLSearchParams(location.search);

const movId = params.get("mov"); // movimiento del banco
const movDesc = params.get("desc");
const movImporte = params.get("imp");
const movFecha = params.get("fecha");


  const [totales, setTotales] = useState({
    subtotal: 0,
    ivaTotal: 0,
    total: 0,
  });

  const [tempFile, setTempFile] = useState(null);

  // ---------------------------------------------------------
  // 🔵 NUEVOS CAMPOS PARA MONEDA INTERNACIONAL
  // ---------------------------------------------------------
  const [moneda, setMoneda] = useState("EUR");
  const [tipoCambio, setTipoCambio] = useState(1); // USD → EUR
  const [importeOriginal, setImporteOriginal] = useState(0);

  // ---------------------------------------------------------
  // Recalcular totales
  // ---------------------------------------------------------
  useEffect(() => {
    let subtotal = 0;
    let ivaTotal = 0;
    lineas.forEach((l) => {
      subtotal += Number(l.precio) || 0;
      ivaTotal += (Number(l.precio) || 0) * (Number(l.iva) || 0);
    });
    setTotales({
      subtotal,
      ivaTotal,
      total: subtotal + ivaTotal,
    });
  }, [lineas]);

  const load = async () => {
    if (!id) return;
    const res = await axios.get(`/compras/${id}`);
    const c = res.data;

    setProveedorNombre(c.proveedorNombre || "");
    setNumeroFactura(c.numeroFactura || "");
    setFecha(c.fecha?.substring(0, 10) || "");
    setFechaVencimiento(c.fechaVencimiento?.substring(0, 10) || "");
    setTipo(c.tipo || "nacional");
    setLineas(c.lineas || [{ concepto: "", precio: 0, iva: 0 }]);
    setTempFile(null);
  };

  useEffect(() => {
    if (id) load();
  }, [id]);

useEffect(() => {
  if (!id && movId) {
    // precargar datos del banco
    setProveedorNombre(movDesc || "");
    setNumeroFactura("");
    setFecha(movFecha || "");
    setFechaVencimiento(movFecha || "");
    
    setLineas([
      {
        concepto: movDesc || "",
        precio: Number(movImporte) || 0,
        iva: 0,
      }
    ]);
  }
}, []);

  

  // ---------------------------------------------------------
  // 🔵 CONVERSIÓN AUTOMÁTICA AL CAMBIAR IMPORTE USD/GBP
  // ---------------------------------------------------------
  const handleImporteOriginal = (valor) => {
    const cantidad = Number(valor) || 0;
    setImporteOriginal(cantidad);

    // Si es EUR no se convierte
    if (moneda === "EUR") {
      const copia = [...lineas];
      copia[0].precio = cantidad;
      setLineas(copia);
      return;
    }

    // Convertir a EUR
    const convertido = cantidad * tipoCambio;

    const copia = [...lineas];
    copia[0].precio = convertido;
    setLineas(copia);
  };

  const handleTipoCambio = (valor) => {
    const tc = Number(valor) || 1;
    setTipoCambio(tc);

    if (moneda !== "EUR") {
      const convertido = importeOriginal * tc;
      const copia = [...lineas];
      copia[0].precio = convertido;
      setLineas(copia);
    }
  };

  // ---------------------------------------------------------
  // Guardar compra (el backend recibe EUR)
  // ---------------------------------------------------------
  const guardar = async () => {
    try {
      const payload = {
        proveedorNombre,
        numeroFactura,
        fecha,
        fechaVencimiento,
        tipo,
        lineas,
        tempFile,
      };

      if (id) {
        await axios.put(`/compras/${id}`, payload);
      } else {
    const r = await axios.post("/compras", payload);

    // si viene de movimiento bancario → asociar
    if (movId) {
      await axios.post("/api/bancos/asociar", {
        movimientoId: Number(movId),
        compraId: r.data.id
      });
    }
}


      alert("Compra guardada correctamente");
      navigate("/compras");
    } catch (error) {
      console.error(error);
      alert("Error guardando compra");
    }
  };

  const addLinea = () =>
    setLineas([...lineas, { concepto: "", precio: 0, iva: 0 }]);

  const updateLinea = (i, field, value) => {
    const copia = [...lineas];
    copia[i][field] = value;
    setLineas(copia);
  };

  const deleteLinea = (i) =>
    setLineas(lineas.filter((_, idx) => idx !== i));

  const subirArchivo = async (e) => {
    try {
      const file = e.target.files[0];
      if (!file) return;

      const fd = new FormData();
      fd.append("archivo", file);

      const res = await axios.post("/compras/ocr-temp", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      const { ocr, tempFile } = res.data || {};

      if (tempFile) setTempFile(tempFile);

      if (ocr) {
        if (ocr.proveedorNombre) setProveedorNombre(ocr.proveedorNombre);
        if (ocr.numeroFactura) setNumeroFactura(ocr.numeroFactura);
        if (ocr.fecha) setFecha(ocr.fecha);
        if (ocr.fechaVencimiento) setFechaVencimiento(ocr.fechaVencimiento);

        if (ocr.lineas && ocr.lineas.length > 0) {
          setLineas(
            ocr.lineas.map((l) => ({
              concepto: l.concepto || "",
              precio: l.precio || 0,
              iva: l.iva ?? 0,
            }))
          );
        }

        alert("Archivo procesado. Datos detectados.");
      } else {
        alert("Archivo subido, pero sin datos OCR.");
      }
    } catch (error) {
      console.error(error);
      alert("Error procesando archivo");
    } finally {
      e.target.value = "";
    }
  };

  return (
    <div className="page-dark">
      {/* HEADER OSCURO */}
      <div
        className="glass-box"
        style={{
          marginBottom: 22,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 20,
        }}
      >
        <div>
          <h1 style={{ margin: 0, fontSize: 26, fontWeight: 700 }}>
            {id ? "Editar compra" : "Nueva compra"}
          </h1>
          <p style={{ marginTop: 4, opacity: 0.85 }}>
            Introduce los datos de la factura de compra.
          </p>
        </div>

        <button
          onClick={() => navigate("/compras")}
          className="glass-btn"
          style={{ padding: "10px 20px", borderRadius: 12 }}
        >
          ← Volver
        </button>
      </div>

      {/* FORMULARIO PRINCIPAL */}
      <div className="glass-box">
      
        {/* ---------------------------------------------------------
            🔵 SECCIÓN NUEVA: MONEDA INTERNACIONAL
        --------------------------------------------------------- */}
        <h3>Moneda de la compra</h3>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
            gap: 14,
            marginBottom: 20,
          }}
        >
          <div>
            <label>Moneda</label>
            <select
              className="glass-input"
              value={moneda}
              onChange={(e) => {
                const m = e.target.value;
                setMoneda(m);

                if (m === "EUR") {
                  setTipoCambio(1);
                  setImporteOriginal(lineas[0].precio || 0);
                }
              }}
            >
              <option value="EUR">EUR (€)</option>
              <option value="USD">USD ($)</option>
              <option value="GBP">GBP (£)</option>
            </select>
          </div>

          {moneda !== "EUR" && (
            <>
              <div>
                <label>Tipo de cambio ({moneda} → EUR)</label>
                <input
                  className="glass-input"
                  type="number"
                  step="0.0001"
                  value={tipoCambio}
                  onChange={(e) => handleTipoCambio(e.target.value)}
                />
              </div>

              <div>
                <label>Importe original en {moneda}</label>
                <input
                  className="glass-input"
                  type="number"
                  value={importeOriginal}
                  onChange={(e) => handleImporteOriginal(e.target.value)}
                />
              </div>

              <div style={{ paddingTop: 25 }}>
                <strong>
                  Equivalente EUR: {(importeOriginal * tipoCambio).toFixed(2)} €
                </strong>
              </div>
            </>
          )}
        </div>

        {/* DATOS PRINCIPALES */}
        <div
          style={{
            display: "grid",
            gap: 16,
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            marginBottom: 18,
          }}
        >
          <div>
  <label>Proveedor</label>

  <ProveedorInput
    value={proveedorNombre}
    onChange={(v) => setProveedorNombre(v)}
  />
</div>


          <div>
            <label>Nº Factura</label>
            <input
              className="glass-input"
              value={numeroFactura}
              onChange={(e) => setNumeroFactura(e.target.value)}
            />
          </div>

          <div>
            <label>Fecha</label>
            <input
              className="glass-input"
              type="date"
              value={fecha}
              onChange={(e) => setFecha(e.target.value)}
            />
          </div>

          <div>
            <label>Tipo</label>
            <select
              className="glass-input"
              value={tipo}
              onChange={(e) => {
                const val = e.target.value;
                setTipo(val);
                if (val === "nacional") {
                  setLineas(lineas.map((l) => ({ ...l, iva: 0.21 })));
                } else {
                  setLineas(lineas.map((l) => ({ ...l, iva: 0 })));
                }
              }}
            >
              <option value="nacional">Nacional</option>
              <option value="internacional">Internacional</option>
              <option value="despacho">Despacho</option>
            </select>
          </div>
        </div>

        {/* VENCIMIENTO + ARCHIVO */}
        <div
          style={{
            display: "grid",
            gap: 16,
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            marginBottom: 18,
          }}
        >
          <div>
            <label>Fecha vencimiento</label>
            <input
              className="glass-input"
              type="date"
              value={fechaVencimiento}
              onChange={(e) => setFechaVencimiento(e.target.value)}
            />
          </div>

          <div>
            <label>Archivo adjunto</label>
            <input
              type="file"
              accept=".pdf,.jpg,.jpeg,.png"
              onChange={subirArchivo}
              className="glass-input"
              style={{ padding: "8px 10px" }}
            />
          </div>
        </div>

        {/* LÍNEAS */}
        <h3 style={{ marginTop: 10 }}>Líneas</h3>

        {lineas.map((l, i) => (
          <div
            key={i}
            style={{
              display: "grid",
              gridTemplateColumns: "minmax(180px, 2fr) repeat(2, 1fr) auto",
              gap: 12,
              alignItems: "end",
              marginBottom: 10,
            }}
          >
            <div>
              <label>Concepto</label>
              <input
                className="glass-input"
                value={l.concepto}
                onChange={(e) => updateLinea(i, "concepto", e.target.value)}
              />
            </div>

            <div>
              <label>Precio (EUR)</label>
              <input
                className="glass-input"
                type="number"
                step="0.01"
                value={l.precio}
                onChange={(e) => updateLinea(i, "precio", e.target.value)}
              />
            </div>

            <div>
              <label>IVA</label>
              <input
                className="glass-input"
                type="number"
                step="0.01"
                value={l.iva}
                onChange={(e) => updateLinea(i, "iva", e.target.value)}
              />
            </div>

            <button
              onClick={() => deleteLinea(i)}
              className="glass-btn"
              style={{
                background: "rgba(239,68,68,0.25)",
                borderColor: "rgba(248,113,113,0.5)",
                padding: "8px 12px",
              }}
            >
              ❌
            </button>
          </div>
        ))}

        <button
          onClick={addLinea}
          className="glass-btn"
          style={{ marginTop: 8, marginBottom: 18 }}
        >
          + Añadir línea
        </button>

        {/* TOTALES */}
        <div
          style={{
            marginTop: 10,
            marginBottom: 20,
            display: "flex",
            flexWrap: "wrap",
            gap: 16,
          }}
        >
          <div>
            <strong>Subtotal:</strong> {totales.subtotal.toFixed(2)} €
          </div>
          <div>
            <strong>IVA:</strong> {totales.ivaTotal.toFixed(2)} €
          </div>
          <div>
            <strong>Total:</strong> {totales.total.toFixed(2)} €
          </div>
        </div>

        {/* BOTONES FINALES */}
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
          <button
            onClick={guardar}
            className="glass-btn"
            style={{ padding: "10px 20px" }}
          >
            Guardar
          </button>

          {!id && (
            <button
              onClick={() => {
                setProveedorNombre("");
                setNumeroFactura("");
                setFecha("");
                setFechaVencimiento("");
                setTipo("nacional");
                setLineas([{ concepto: "", precio: 0, iva: 0.21 }]);
                setTempFile(null);
              }}
              className="glass-btn"
            >
              Nuevo
            </button>
          )}

          <button
            onClick={() => navigate("/compras")}
            className="glass-btn"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}
